wbApp.controller('EventDetailCtrl', ['$scope', '$translate', 'securitySvc', 'clientSchedulerSvc', 'notificationSvc', 'tenantSettingSvc',
function ($scope, $translate, securitySvc, clientSchedulerSvc, notificationSvc, tenantSettingSvc) {

    $scope.showCourseWaitQueueIndexInClient = tenantSettingSvc.settings.showCourseWaitQueueIndexInClient;



    $scope.eventDetail;
    $scope.isSaving = false;

    if (securitySvc.isAuthenticated()) {
        var promise = clientSchedulerSvc.getUserScheduleDetail(
            $scope.eventModal.currentStudent
                ? $scope.eventModal.currentStudent.userID
                : securitySvc.loggedInUser().userID,
            $scope.eventModal.action.courseScheduleID);

        promise.then(function (data) {
            $scope.eventDetail = data;
            $scope.compensationGrpHelp = $translate.instant('TXT_HLP_COMPENSATION_GROUP_HELP').f(data.compensationGroup);
        });
    }

    $scope.detailIsUnchanged = function (data) {
        if (!securitySvc.isAuthenticated()) {
            return false; // Special case when user is not logged in, we will show login adver on click
        }

        if (data) {
            return !data.isDirty;
        }
        return true;
    };

    $scope.onAttendanceSave = function (detailModel) {
        if (!securitySvc.isAuthenticated()) {
            notificationSvc.advertiseLogin();
            return;
        }

        $scope.isSaving = true;
        $scope.detailError = null;

        clientSchedulerSvc.setNewAttendance(
            $scope.eventModal.currentStudent
                ? $scope.eventModal.currentStudent.userID
                : securitySvc.loggedInUser().userID,
            $scope.eventModal.action.courseScheduleID,
            detailModel)
        .then(function () {
            $scope.isSaving = false;
            $scope.$hide();
            $scope.onSaved();
        }, function (rejectReason) {
            $scope.isSaving = false;
            $scope.detailError = rejectReason;
        });
    }

    // #region Tabs

    $scope.detailTabs = [];

    if (securitySvc.isAuthenticated()) {
        $scope.detailTabs.push({
            title: 'TXT_TAB_ATTENDANCE',
            template: "schedule/event-detail-dialog/attendance-tab.html"
        });
    }

    $scope.detailTabs.push({
        title: $scope.eventModal.action.subjectCategoryID === 1 ? 'TXT_TAB_COURSE_DETAIL' : 'TXT_TAB_ACTION_DETAIL',
        template: "schedule/event-detail-dialog/course-description-tab.html"
    });

    $scope.detailTabs.activeTab = 0;

    // #endregion
}]);